import { useEffect, useMemo, useState } from "react";

const NEON = ["#00F0FF", "#FF007F", "#F4D03F", "#B084FF", "#00FFB2", "#7DF9FF"];

export default function ConfettiBurst({ active, count = 90, duration = 4500, onDone }) {
  const [pieces, setPieces] = useState([]);

  useEffect(() => {
    if (!active) { setPieces([]); return; }
    const arr = Array.from({ length: count }).map((_, i) => ({
      id: i,
      left: Math.random() * 100,
      color: NEON[i % NEON.length],
      delay: Math.random() * 300,
      duration: 2600 + Math.random() * 2400,
      size: 6 + Math.random() * 8,
      rotate: Math.random() * 360,
      drift: (Math.random() - 0.5) * 40,
    }));
    setPieces(arr);
    const t = setTimeout(() => { setPieces([]); onDone?.(); }, duration);
    return () => clearTimeout(t);
  }, [active, count, duration, onDone]);

  const styles = useMemo(() => `
    @keyframes legacy-confetti-fall {
      0%   { transform: translate(0, -20vh) rotate(0deg); opacity: 0; }
      10%  { opacity: 1; }
      100% { transform: translate(var(--drift), 110vh) rotate(720deg); opacity: 0.2; }
    }
  `, []);

  if (!pieces.length) return null;
  return (
    <div className="pointer-events-none fixed inset-0 z-[100] overflow-hidden" data-testid="confetti-burst">
      <style>{styles}</style>
      {pieces.map((p) => (
        <span
          key={p.id}
          style={{
            position: "absolute",
            top: 0,
            left: `${p.left}%`,
            width: p.size,
            height: p.size * 0.4,
            backgroundColor: p.color,
            boxShadow: `0 0 8px ${p.color}`,
            transform: `rotate(${p.rotate}deg)`,
            animation: `legacy-confetti-fall ${p.duration}ms cubic-bezier(0.19, 1, 0.22, 1) ${p.delay}ms forwards`,
            ["--drift"]: `${p.drift}vw`,
          }}
        />
      ))}
    </div>
  );
}
